import { render } from "./StatisticsChart.vue?vue&type=template&id=87c8430e&scoped=true"
import script from "./StatisticsChart.vue?vue&type=script&lang=js"
export * from "./StatisticsChart.vue?vue&type=script&lang=js"

import "./StatisticsChart.vue?vue&type=style&index=0&id=87c8430e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87c8430e"]])

export default __exports__